export default __webpack_public_path__ + "static/media/video_preview_2.7e6b3f66.png";